import { httpRequest } from "@services/http"


export class CommandGetEngagementLaunchAnalytics {
    async run(engagementId: number, launchId: number) {
      const url = `${
        import.meta.env.VITE_API_PLATFORM_SERVICE_URL
      }api/v1/engagements/${engagementId}/analytics?&charts=launch-performance&launch_id=${launchId}`
      try {
        const response = await httpRequest<any>(url, { method: "GET" })
        return response
      } catch (error) {
        console.error("Error fetching data:", error)
        throw error
      }
    }

}